import InputCounter from './input-counter'

export default InputCounter
